

























































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import forEach from 'lodash/forEach'
import {
  BCol,
  BRow,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BIconArrowLeft
} from 'bootstrap-vue'

import { app } from '../main'
import { CartItem } from '../store/cart/types'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import store from '../store'

import ProductsApi from '@cms-labs/typescript-api/products'
import OrdersApi from '@cms-labs/typescript-api/orders'
import { ProductItemPublic } from '@cms-labs/typescript-api/products/types'
import {
  PaymentCheckoutModalResponse,
  PaymentCheckoutModalErrorResponse
} from '../lib/rbm-checkout/types'
import {
  emptyCustomerInfo,
  emptyShippingAddress,
  emptyBillingAddress
} from '@cms-labs/typescript-api/orders/constants'
import {
  OrderShippingAddress,
  OrderBillingAddress,
  OrderCustomerInfo,
  OrderInstance,
  OrderProduct
} from '@cms-labs/typescript-api/orders/types'

@Component({
  components: {
    BCol,
    BRow,
    BForm,
    BButton,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BIconArrowLeft,
    LoadingOverlay
  }
})
export default class CheckoutPage extends Vue {
  private isLoading = false
  private orderSection: 'shipping' | 'customer' | 'address' | 'payment' | 'completed' = 'customer'
  private shippingMethod: 'local' | 'national' | null = null
  private orderProducts: OrderProduct[] = []
  private customerInfo: OrderCustomerInfo = emptyCustomerInfo
  private shippingAddress: OrderShippingAddress = emptyShippingAddress
  private billingAddress: OrderBillingAddress = emptyBillingAddress
  private orderInfo: OrderInstance = {
    customer_info: this.customerInfo,
    total: this.orderTotal,
    notes: '',
    products: this.orderProducts,
    shipping_address: this.shippingAddress,
    billing_address: this.billingAddress
  }

  private createdOrder: OrderInstance = cloneDeep(this.orderInfo)
  private orderWasCreated = false
  private paymentEnv: 'local' | 'stg' | 'prod' = 'prod'

  private mounted () {
    // Add Redeban PaymentCheckout Script Module
    const rbmPaymentScript = document.createElement('script')
    rbmPaymentScript.setAttribute(
      'src',
      'https://cdn.globalpay.com.co/ccapi/sdk/payment_checkout_2.0.0.min.js'
    )
    document.head.appendChild(rbmPaymentScript)
  }

  private async created (): Promise<void> {
    try {
      this.isLoading = true
      this.orderSection = 'customer'
      forEach(this.cartItems(), (item) => {
        this.orderProducts.push({
          uuid: item.uuid,
          name: item.name,
          thumbnail: item.thumbnail,
          reference: item.reference,
          quantity: item.quantity,
          price: item.price,
          discount_pct: item.discount_pct
        })
      })

      this.paymentEnv = 'prod'
      if (
        window.location.href.includes('localhost:') ||
        window.location.href.includes('127.0.0.1:')
      ) { this.paymentEnv = 'stg' }

      this.isLoading = false
    } catch (error) { this.isLoading = false }
    try {
      this.isLoading = true
      await this.checkCartItemsUpToDate()
      this.isLoading = false
    } catch (error) { this.isLoading = false }
  }

  private moveToOrderSection (
    event: Event | null,
    section: 'shipping' | 'customer' | 'address' | 'payment' | 'completed'
  ) {
    if (event) { event.preventDefault() }
    // TODO Save this to local storage
    this.orderSection = section
  }

  private isActiveSectionInMap (section: string) {
    if (section === 'customer') {
      return true
    }
  }

  public get orderTotal (): number {
    return store.cart.orderTotal
  }

  private getPaymentCheckoutModal () {
    /* eslint-disable no-eval, no-undef, new-cap */
    // ----------------------------------------------------------------
    // | PaymentCheckout was imported from script tag in this.mounted |
    // ----------------------------------------------------------------

    let clientAppCode = 'COMCMS-GLP-CLIENT'
    let clientAppKey = 'I8NjVaThn53qIO0i65CjGOWozRU5Ae'
    if (
      window.location.href.includes('localhost:') ||
      window.location.href.includes('127.0.0.1:')
    ) {
      clientAppCode = 'COMERCMS-GLP-CLIENT'
      clientAppKey = 'IQBTHRtwR1aJJ1tPIeGp1NPoFtMNh2'
    }

    // @ts-ignore
    const paymentCheckout = new PaymentCheckout.modal({
      // TODO add conditional to decide if to use stg or prod credential
      client_app_code: clientAppCode,
      client_app_key: clientAppKey,
      locale: 'es', // Language
      env_mode: this.paymentEnv,
      onResponse: (
        response: PaymentCheckoutModalResponse |
          PaymentCheckoutModalErrorResponse
      ) => { this.handlePaymentResponse(response) }
    })
    return paymentCheckout
  }

  private async openPaymentModal (): Promise<void> {
    if (this.orderProducts.length > 0) {
      this.isLoading = true
      try {
        await this.checkCartItemsUpToDate()
      } catch (error) { this.isLoading = false }
      // Generate a pseudo-random number for BE to
      // recognize the payment's webhook's correct order.
      const currentDate: number = new Date().getTime()
      const randNum: number = Math.floor(Math.random() * Math.floor(999))
      const orderReference = `${currentDate}-${randNum}`

      const paymentCheckout = this.getPaymentCheckoutModal()
      paymentCheckout.open({
        user_id: this.orderInfo.customer_info.identification_number,
        user_email: this.orderInfo.customer_info.email,
        user_phone: this.orderInfo.customer_info.phone_number,
        order_description: this.getOrderDescription(this.orderInfo),
        order_amount: this.orderInfo.total,
        order_reference: orderReference,
        order_vat: 0
      })
      this.isLoading = false
    }
  }

  private async checkCartItemsUpToDate (): Promise<void> {
    // @TODO Put this function in a "util" file cause it is being used
    // in other places as well... copy and pasted
    const http = new ProductsApi(app)
    // @ts-ignore
    for (const localItem of this.cartItems()) {
      try {
        const cloudItem: ProductItemPublic = await http.getProductInstance(localItem.uuid)
        if (
          localItem.quantity &&
          cloudItem.stock &&
          localItem.quantity > cloudItem.stock
        ) {
          store.cart.removeItem(localItem.uuid)
          this.$bvToast.toast(
            'Porfavor vuelva a agregar los productos en su carrito', {
              title: `Sólo quedan ${cloudItem.stock} unidades del producto: ${localItem.name}.`,
              variant: 'danger',
              autoHideDelay: 10000
            }
          )
        }
        if (
          localItem.name !== cloudItem.name ||
          localItem.price !== cloudItem.price ||
          localItem.discount_pct !== cloudItem.discount_pct
        ) {
          store.cart.removeItem(localItem.uuid)
          this.$bvToast.toast(
            'Porfavor vuelva a agregar los productos en su carrito', {
              title: 'La info. de su(s) producto(s) está desactualizada.',
              variant: 'danger',
              autoHideDelay: 10000
            }
          )
        }
      } catch (error) {
        if (error.response.status === 404) {
          store.cart.removeItem(localItem.uuid)
          this.$bvToast.toast(
            'Porfavor vuelva a agregar los productos en su carrito', {
              title: `El producto: ${localItem.name} ya no está disponible.`,
              variant: 'danger',
              autoHideDelay: 10000
            }
          )
          this.isLoading = false
        }
      }
    }
  }

  public cartItems (): CartItem[] {
    return cloneDeep(store.cart.items)
  }

  private async handlePaymentResponse (
    response:
      PaymentCheckoutModalResponse |
      PaymentCheckoutModalErrorResponse
  ): Promise<void> {
    /*
    @TODO Show better error messages for user to be aware of what happened.
    Example: if the carrier denied the card and it needs to try with another
    card. This is how a transaction response looks like:

    {
      "transaction":{
          "status":"failure",
          "payment_date":null,
          "amount":1000.0,
          "authorization_code":null,
          "installments":1,
          "dev_reference":"1604850492826-513",
          "message":"Rechazo General",
          "carrier_code":"05",
          "id":"RB-5906358",
          "status_detail":9
      },
      "card":{
          "bin":"549112",
          "status":"",
          "token":"",
          "expiry_year":"2023",
          "expiry_month":"6",
          "transaction_reference":"RB-5906358",
          "type":"mc",
          "number":"0876",
          "origin":"GlobalPay"
      }
    }

    Use the status_detail to determine what to show (create a map), based on
    the info in https://developers.globalpay.com.co/api/en/#status-details
    */

    this.isLoading = true

    if ('error' in response) {
      this.$bvToast.toast(
        response.error.description, {
          title: 'Lo sentimos, su pago no ha sido procesado.',
          variant: 'danger',
          autoHideDelay: 6000
        }
      )
      this.isLoading = false
      return
    }

    if ('transaction' in response) {
      if (
        response.transaction.status_detail === 0 ||
        response.transaction.status_detail === 1 ||
        response.transaction.status_detail === 3
      ) {
        try {
          // Grab necessary values and create the order
          this.orderInfo.transaction_id = response.transaction.id
          this.orderInfo.authorization_code = response.transaction
            .authorization_code
          this.orderInfo.dev_reference = response.transaction
            .dev_reference

          const http = new OrdersApi(app)
          this.createdOrder = await http.createOrderInstance(this.orderInfo)

          // Query the order until payment/status is updated

          this.moveToOrderSection(null, 'completed')
          store.cart.emptyCart()
        } catch (error) { this.isLoading = false }
      } else {
        this.$bvToast.toast(
          'Comuníquese con nosotros al 368-4554 (B/quilla).', {
            title: 'Lo sentimos, su pago no ha sido procesado.',
            variant: 'danger',
            autoHideDelay: 6000
          }
        )
      }
    }

    this.isLoading = false
  }

  private getOrderDescription (order: OrderInstance): string {
    let description = ''
    forEach(order.products, (product) => {
      const price = Number(product.price).toLocaleString()
      description += `${product.name} ${product.quantity} x $${price} | `
    })
    return '| ' + description
  }

  @Watch('shippingMethod')
  onShippingMethodChanged (value: string) {
    if (value === 'local') {
      this.shippingAddress.city = 'Barranquilla'
      this.shippingAddress.state = 'Atlántico'
      this.billingAddress.city = 'Barranquilla'
      this.billingAddress.state = 'Atlántico'
    }
  }
}
